module.exports = __webpack_public_path__ + "img/land_characteristics_valley@2x.aff47365.png";